module.exports = ".list-group-item:hover{\r\n    font-weight: 400;\r\n    cursor: pointer;\r\n    background-color: aqua;\r\n  }"